// Anonymous, non-identifying browser id used to recognise a returning visitor across sessions.

const VISITOR_ID_KEY = "dc_vid";

const createId = () => {
    try {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    } catch (e) {
        // Falls through to the manual generator below.
    }

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * Returns this browser's visitor id, creating and persisting one on first use. Deliberately survives
 * logout: it identifies the browser, never the person, and carries no account or patient data.
 */
export const getVisitorId = () => {
    try {
        let id = localStorage.getItem(VISITOR_ID_KEY);
        if (!id) {
            id = createId();
            localStorage.setItem(VISITOR_ID_KEY, id);
        }
        return id;
    } catch (e) {
        return undefined;
    }
};
